(function () {
  'use strict';

  var selectedCharacter = null;
  var selectedVoice = null;
  var audioMode = 'text';
  var audioURL = '';
  var audioSeconds = 0;
  var audioPreviewURL = '';
  var searchTimer = 0;
  var voiceTimer = 0;
  var pollTimer = 0;

  function selectedModel() {
    return byID('it-model').value;
  }

  function modelName() {
    return selectedModel() === 'manifold-h3' ? 'H3' : 'InfiniTalk';
  }

  function byID(id) {
    return document.getElementById(id);
  }

  function setStatus(message, error) {
    var node = byID('it-status');
    node.textContent = message;
    node.classList.toggle('it-error', !!error);
  }

  function requireLogin() {
    if (window.NetwrckTools && typeof window.NetwrckTools.requireLogin === 'function') {
      window.NetwrckTools.requireLogin();
      return;
    }
    window.location.href = '/login?next=' + encodeURIComponent(location.pathname + location.search);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function imageURL(character) {
    if (character.image_url) return character.image_url;
    var file = character.avatar_file_name || '';
    if (!file) return '';
    if (/^https:\/\//.test(file)) return file;
    var bucket = character.bucket_name || 'netwrckstatic.netwrck.com';
    if (!/^https?:\/\//.test(bucket)) bucket = 'https://' + bucket;
    return bucket.replace(/\/$/, '') + '/static/uploads/' + encodeURIComponent(file);
  }

  function selectCharacter(character) {
    var url = imageURL(character);
    if (!url) return;
    selectedCharacter = character;
    selectedCharacter.image_url = url;
    byID('it-selected-image').src = url;
    byID('it-selected-name').textContent = character.name || character.title || 'Uploaded portrait';
    byID('it-selected-meta').textContent = character.description || character.source || 'Ready to animate';
    document.querySelectorAll('.it-card').forEach(function (card) {
      card.classList.toggle('it-on', card.dataset.id === String(character.id || character.url_name || ''));
    });
  }

  function characterCard(character) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'it-card';
    button.dataset.id = String(character.id || character.url_name || '');
    var image = document.createElement('img');
    image.loading = 'lazy';
    image.src = imageURL(character);
    image.alt = character.name || 'AI character';
    var name = document.createElement('span');
    name.textContent = character.name || character.title || 'AI character';
    button.append(image, name);
    button.addEventListener('click', function () { selectCharacter(character); });
    return button;
  }

  async function loadCharacters() {
    var gallery = byID('it-gallery');
    var query = byID('it-character-search').value.trim() || 'character';
    gallery.innerHTML = '<div class="it-empty">Searching characters…</div>';
    try {
      var response = await fetch('/api/search-ai?query=' + encodeURIComponent(query) + '&limit=80', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Character search unavailable.');
      var characters = await response.json();
      if (!Array.isArray(characters)) characters = [];
      gallery.replaceChildren();
      byID('it-result-count').textContent = characters.length + ' results';
      if (!characters.length) {
        gallery.innerHTML = '<div class="it-empty">No characters found. Try another search or upload a portrait.</div>';
        return;
      }
      characters.forEach(function (character) { gallery.appendChild(characterCard(character)); });
      if (!selectedCharacter) selectCharacter(characters[0]);
    } catch {
      gallery.innerHTML = '<div class="it-empty">Character search is unavailable. Upload a portrait to continue.</div>';
    }
  }

  function voiceKey(voice) {
    var file = String(voice.url || '').split('/').pop() || '';
    return file.replace(/\.(wav|opus|mp3|m4a)$/i, '') || voice.provider_id || '';
  }

  function selectVoice(voice) {
    selectedVoice = voice;
    document.querySelectorAll('.it-voice').forEach(function (node) {
      node.classList.toggle('it-on', node.dataset.key === voiceKey(voice));
    });
    var player = byID('it-voice-preview');
    player.src = voice.preview_url || voice.url || '';
    player.play().catch(function () {});
  }

  function voiceCard(voice) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'it-voice';
    button.dataset.key = voiceKey(voice);
    var name = document.createElement('strong');
    name.textContent = voice.title || voice.name || 'Voice';
    var details = document.createElement('small');
    details.textContent = voice.description || (voice.tags || []).slice(0, 4).join(', ') || voice.provider || '';
    button.append(name, details);
    button.addEventListener('click', function () { selectVoice(voice); });
    return button;
  }

  async function loadVoices() {
    var host = byID('it-voices');
    var query = byID('it-voice-search').value.trim();
    try {
      var response = await fetch('/api/search-audio?kind=voice&limit=40&query=' + encodeURIComponent(query), { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Voice search unavailable.');
      var voices = await response.json();
      if (!Array.isArray(voices)) voices = [];
      host.replaceChildren();
      if (!voices.length) {
        host.innerHTML = '<div class="it-empty">No matching voices. The default voice will be used.</div>';
        selectedVoice = null;
        return;
      }
      voices.forEach(function (voice) { host.appendChild(voiceCard(voice)); });
      if (!selectedVoice) selectVoice(voices[0]);
    } catch {
      host.innerHTML = '<div class="it-empty">Voice search unavailable. The default voice will be used.</div>';
    }
  }

  function textSeconds() {
    var length = Array.from(byID('it-script').value.trim()).length;
    if (selectedModel() === 'manifold-h3') return length ? clamp(Math.ceil(length / 14), 4, 60) : 4;
    return length ? clamp(length / 14, 41 / 25, 721 / 25) : 41 / 25;
  }

  function generationSeconds() {
    if (audioMode !== 'upload' || audioSeconds <= 0) return textSeconds();
    if (selectedModel() === 'manifold-h3') return clamp(Math.ceil(audioSeconds), 4, 15);
    return clamp(audioSeconds, 41 / 25, 721 / 25);
  }

  function frameCount() {
    return clamp(Math.round(generationSeconds() * 25), 41, 721);
  }

  function credits() {
	if (selectedModel() === 'manifold-h3') return Math.ceil(generationSeconds() * 30);
    var videoCredits = Math.ceil(frameCount() / 25 * 30);
    if (audioMode === 'upload') return videoCredits;
    var length = Array.from(byID('it-script').value.trim()).length;
    return videoCredits + (length ? Math.max(1, Math.ceil(length / 1000 * 6)) : 0);
  }

  function refreshEstimate() {
    var seconds = selectedModel() === 'manifold-h3' ? generationSeconds() : frameCount() / 25;
    var length = Array.from(byID('it-script').value).length;
    byID('it-character-count').textContent = length + (length === 1 ? ' character' : ' characters');
    byID('it-text-duration').textContent = seconds.toFixed(2).replace(/\.00$/, '') + ' seconds';
    byID('it-duration-label').textContent = seconds.toFixed(2).replace(/\.00$/, '') + ' second video';
    byID('it-credit-label').textContent = credits() + ' credits';
    byID('it-generate').textContent = 'Generate ' + modelName() + ' video · ' + credits() + ' credits';
  }

  function setModel() {
    var h3 = selectedModel() === 'manifold-h3';
    byID('it-h3-options').hidden = !h3;
    byID('it-fal-options').hidden = h3;
    byID('it-native-voice').hidden = !h3;
    byID('it-fal-voice').hidden = h3;
    byID('it-model-label').textContent = h3 ? 'Model: H3 via ManifoldGen' : 'Model: fal-ai/infinitalk';
    byID('it-audio-status').textContent = h3
      ? 'MP3, WAV, M4A, OGG or WebM. H3 driving audio supports up to 15 seconds.'
      : 'MP3, WAV, M4A, OGG or WebM. InfiniTalk supports up to 28.84 seconds.';
    if (!h3 && !selectedVoice) loadVoices();
    refreshEstimate();
  }

  function setAudioMode(mode) {
    audioMode = mode;
    byID('it-text-pane').hidden = mode !== 'text';
    byID('it-upload-pane').hidden = mode !== 'upload';
    byID('it-audio-tabs').querySelectorAll('.it-tab').forEach(function (tab) {
      tab.classList.toggle('it-on', tab.dataset.mode === mode);
    });
    refreshEstimate();
  }

  async function uploadFile(file, prefix, fallbackExtension) {
    var extension = (file.name.split('.').pop() || fallbackExtension).toLowerCase();
    var signed = await window.getSignedURLAndUpload(file, file.type, prefix + '-' + Date.now() + '.' + extension);
    var bucket = signed.bucket_name || 'netwrckstatic.netwrck.com';
    var base = /^https?:\/\//.test(bucket) ? bucket : 'https://' + bucket;
    return base.replace(/\/$/, '') + '/' + String(signed.object_path || '').replace(/^\//, '');
  }

  async function uploadPortrait(file) {
    if (!file) return;
    setStatus('Uploading portrait…', false);
    try {
      var url = await uploadFile(file, 'infinitalk-portrait', 'webp');
      selectCharacter({ name: file.name, image_url: url, source: 'Uploaded portrait' });
      setStatus('Portrait uploaded.', false);
    } catch {
      setStatus('Portrait upload failed.', true);
    }
  }

  function readAudioDuration(file) {
    return new Promise(function (resolve, reject) {
      if (audioPreviewURL) URL.revokeObjectURL(audioPreviewURL);
      audioPreviewURL = URL.createObjectURL(file);
      var audio = byID('it-audio-preview');
      audio.onloadedmetadata = function () {
        if (!Number.isFinite(audio.duration) || audio.duration <= 0) reject(new Error('Could not read audio duration.'));
        else resolve(audio.duration);
      };
      audio.onerror = function () {
        reject(new Error('Could not read audio file.'));
      };
      audio.src = audioPreviewURL;
    });
  }

  async function uploadAudio(file) {
    if (!file) return;
    var status = byID('it-audio-status');
    status.textContent = 'Reading and uploading audio…';
    try {
      audioSeconds = await readAudioDuration(file);
      audioURL = await uploadFile(file, 'infinitalk-audio', 'mp3');
      var maximum = selectedModel() === 'manifold-h3' ? 15 : 721 / 25;
      status.textContent = audioSeconds > maximum
		? 'Audio uploaded. Output will use the first ' + maximum.toFixed(2).replace(/\.00$/, '') + ' seconds.'
        : 'Audio uploaded · ' + audioSeconds.toFixed(2) + ' seconds.';
      refreshEstimate();
    } catch (error) {
      audioURL = '';
      audioSeconds = 0;
      status.textContent = error.message || 'Audio upload failed.';
    }
  }

  function videoURL(result) {
    if (!result) return '';
    if (typeof result.video_url === 'string') return result.video_url;
    if (result.video && typeof result.video.url === 'string') return result.video.url;
    return result.result ? videoURL(result.result) : '';
  }

  function showResult(url) {
    byID('it-video').src = url;
    byID('it-download').href = url;
    byID('it-download').textContent = /\.webm(\?|$)/i.test(url) ? 'Download WebM' : 'Download video';
    byID('it-result').classList.add('it-on');
    byID('it-progress').hidden = true;
    byID('it-generate').disabled = false;
  }

  function pollJob(jobID) {
    window.clearTimeout(pollTimer);
    pollTimer = window.setTimeout(async function () {
      try {
        var response = await fetch('/api/fal/status/' + encodeURIComponent(jobID), { credentials: 'same-origin' });
        var data = await response.json();
        if (data.status === 'completed') {
          var url = videoURL(data.result || data);
          if (!url) throw new Error('No video returned.');
          showResult(url);
          setStatus(modelName() + ' video ready.', false);
          return;
        }
        if (data.status === 'failed') throw new Error((data.error || 'Generation failed.') + ' Credits were refunded.');
        setStatus('Rendering ' + modelName() + ' video' + (data.progress ? ' · ' + data.progress + '%' : '') + '…', false);
        pollJob(jobID);
      } catch (error) {
        setStatus(error.message || 'Could not read generation status.', true);
        byID('it-progress').hidden = true;
        byID('it-generate').disabled = false;
      }
    }, 4000);
  }

  async function generate() {
    if (!selectedCharacter || !selectedCharacter.image_url) {
      setStatus('Choose or upload a portrait first.', true);
      return;
    }
    var text = byID('it-script').value.trim();
    if (audioMode === 'text' && !text) {
      setStatus('Write what the character should say.', true);
      return;
    }
    if (audioMode === 'upload' && !audioURL) {
      setStatus('Upload a driving audio file first.', true);
      return;
    }
    var button = byID('it-generate');
    button.disabled = true;
    byID('it-progress').hidden = false;
    byID('it-result').classList.remove('it-on');
    setStatus('Submitting ' + modelName() + ' job…', false);
    var seed = Number(byID('it-seed').value);
    var body = {
      image_url: selectedCharacter.image_url,
      portrait_slug: selectedCharacter.url_name || '',
      text: audioMode === 'text' ? text : '',
      audio_url: audioMode === 'upload' ? audioURL : '',
      prompt: byID('it-prompt').value.trim(),
	  backend: selectedModel(),
	  seconds: generationSeconds(),
	  size: byID('it-size').value,
	  aspect_ratio: byID('it-aspect-ratio').value,
      resolution: byID('it-resolution').value,
      acceleration: byID('it-acceleration').value,
      seed: Number.isFinite(seed) ? clamp(Math.round(seed), 0, 4294967295) : 42,
      response_mode: 'polling',
    };
    if (selectedModel() === 'infinitalk') body.num_frames = frameCount();
    if (selectedModel() === 'infinitalk' && audioMode === 'text' && selectedVoice) {
      body.voice_key = voiceKey(selectedVoice);
      body.voice_provider = selectedVoice.provider || '';
      body.voice_id = selectedVoice.provider_id || '';
      body.ref_audio_url = selectedVoice.url || '';
    }
    try {
      var response = await fetch('/api/infinitalk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body),
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        if (response.status === 401) requireLogin();
        throw new Error(data.error || 'Generation failed.');
      }
      setStatus('Queued · ' + data.credits_charged + ' credits charged. Rendering…', false);
      pollJob(data.job_id);
    } catch (error) {
      setStatus(error.message || 'Generation failed.', true);
      byID('it-progress').hidden = true;
      button.disabled = false;
    }
  }

  function init() {
    if (!byID('it-gallery')) return;
    byID('it-character-search-button').addEventListener('click', loadCharacters);
    byID('it-character-search').addEventListener('input', function () {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(loadCharacters, 220);
    });
    byID('it-voice-search').addEventListener('input', function () {
      window.clearTimeout(voiceTimer);
      voiceTimer = window.setTimeout(loadVoices, 220);
    });
	byID('it-model').addEventListener('change', setModel);
    byID('it-audio-tabs').addEventListener('click', function (event) {
      var tab = event.target.closest('.it-tab');
      if (tab) setAudioMode(tab.dataset.mode);
    });
    byID('it-image-file').addEventListener('change', function (event) { uploadPortrait(event.target.files[0]); });
    byID('it-audio-file').addEventListener('change', function (event) { uploadAudio(event.target.files[0]); });
    byID('it-script').addEventListener('input', refreshEstimate);
    byID('it-generate').addEventListener('click', generate);
    loadCharacters();
    setModel();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
